var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52001 0.43639C3.72791 0.161481 4.0535 0 4.4 0H17.6C17.9465 0 18.2721 0.161481 18.48 0.43639L21.78 4.80003C21.923 4.98875 22 5.21891 22 5.45455V20.7273C22 21.6 21.6524 22.4291 21.0331 23.04C20.4149 23.6509 19.5756 24 18.7 24H3.3C2.4244 24 1.58513 23.6509 0.966931 23.04C0.347631 22.4291 0 21.6 0 20.7273V5.45455C0 5.21891 0.0770134 4.98875 0.220013 4.80003L3.52001 0.43639ZM4.95 2.18182L2.2 5.81783V20.7273C2.2 21.0218 2.31553 21.2946 2.52233 21.5018C2.72803 21.6982 3.0085 21.8182 3.3 21.8182H18.7C18.9915 21.8182 19.272 21.6982 19.4777 21.5018C19.6845 21.2946 19.8 21.0218 19.8 20.7273V5.81783L17.05 2.18182H4.95Z",
    fill: "#67665E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5.45456C0 4.85237 0.4928 4.36365 1.1 4.36365H20.9C21.5072 4.36365 22 4.85237 22 5.45456C22 6.05674 21.5072 6.54547 20.9 6.54547H1.1C0.4928 6.54547 0 6.05674 0 5.45456Z",
    fill: "#67665E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.6 8.72729C7.2072 8.72729 7.7 9.21602 7.7 9.8182C7.7 10.6866 8.04763 11.5189 8.66693 12.1309C9.28513 12.7418 10.1244 13.0909 11 13.0909C11.8756 13.0909 12.7149 12.7418 13.3331 12.1309C13.9524 11.5189 14.3 10.6866 14.3 9.8182C14.3 9.21602 14.7928 8.72729 15.4 8.72729C16.0072 8.72729 16.5 9.21602 16.5 9.8182C16.5 11.2647 15.9203 12.6545 14.8896 13.68C13.8578 14.6945 12.4586 15.2727 11 15.2727C9.5414 15.2727 8.14219 14.6945 7.11039 13.68C6.07969 12.6545 5.5 11.2647 5.5 9.8182C5.5 9.21602 5.9928 8.72729 6.6 8.72729Z",
    fill: "#67665E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPay);
export default __webpack_public_path__ + "static/media/pay.9f57db14876d28df42bf6c368292aa32.svg";
export { ForwardRef as ReactComponent };